import { useQuery } from '@tanstack/react-query'
import { tasksApi } from '@/lib/api'

export function useTask(uuid: string | undefined) {
  return useQuery({
    queryKey: ['task', uuid],
    queryFn: async () => (await tasksApi.getByUuid(uuid!)).data,
    enabled: !!uuid,
    refetchOnMount: 'always',
    staleTime: 0,
  })
}
